(() => {
  angular
    .module('gm.common.aurum-activity', [
      'gm.common.websockets'
    ])
    .factory('gmAurumActivity', gmAurumActivityFactory);

  function gmAurumActivityFactory(
    $timeout,
    $interval,
    $q,
    gmSocketFactory,
    GmyVaults,
    GmyUtils
  ) {
    'ngInject';

    const SIMULATED_INTERVAL = 5000;

    const activityObserverCallbacks = [];
    let socket;

    return {
      connect,
      disconnect,
      formatActivity,
      getRandomActivity,
      notifyActivityObservers,
      registerActivityObserver,
    };

    function connect(simulateData = false) {
      if (simulateData) {
        return $interval(() => {
          notifyActivityObservers(getRandomActivity());
        }, SIMULATED_INTERVAL);
      }

      return $q((resolver) => {
        socket = gmSocketFactory.create('/ws/aurum/activity');

        socket.on('message', (data) => {
          if (data) {
            $timeout(() => {
              notifyActivityObservers(data);
            });
          }
        });

        socket.once('message', resolver);
        socket.connect();
      });
    }

    function disconnect() {
      if (socket) {
        socket.disconnect();
      }
      socket = null;
    }

    function formatActivity(activity) {
      activity.ts = Date.now();

      switch (activity.type) {
        case 'InvoiceSent':
          activity.type = 'Invoice Sent';
          break;
        case 'Payment':
          activity.type = 'Transfer';
          break;
        default:
          break;
      }

      if ('optionalVaultId' in activity) {
        activity.vault = GmyVaults.getVaultBaseInfoById(activity.optionalVaultId);
      } else {
        activity.vault = GmyVaults.getVaultBaseInfoById(GmyUtils.randomIntFromInterval(1, 7));
      }

      return activity;
    }

    function getRandomActivity() {
      return [{
        gauAmount: GmyUtils.randomFloatFromInterval(0.023, 4.120, 3),
        type: 'transfer',
      }];
    }

    function notifyActivityObservers(activity) {
      angular.forEach(activityObserverCallbacks, (callback) => {
        callback(activity);
      });
    }

    function registerActivityObserver(callback) {
      activityObserverCallbacks.push(callback);
    }
  }
})();
